import SigningPage from './pages/SigningPage'

export const SignersRoutes = [
  {
    path: '/firmadocto',
    name: 'Signing',
    component: SigningPage
  }
]
